import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../api/axios";
import ProductList from "../components/ProductList";

const BrandProducts = () => {
  const { brandName } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrandProducts = async () => {
      try {
        const { data } = await API.get(`/products/brand/${brandName}`);
        setProducts(data);
      } catch (error) {
        console.error("Error obteniendo productos de la marca:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBrandProducts();
  }, [brandName]);

  return (
    <div className="container mx-auto mt-10 px-4">
      <h2 className="text-2xl font-bold text-center mb-6">Productos de {brandName}</h2>
      {loading ? (
        <p className="text-center text-gray-500">⏳ Cargando productos...</p>
      ) : products.length > 0 ? (
        <ProductList products={products} />
      ) : (
        <p className="text-center">No hay productos disponibles para esta marca.</p>
      )}
    </div>
  );
};

export default BrandProducts;
